import React from 'react';

const CtaLink = ({ href = '#', primaryText = 'Explore Our Services', ariaLabel = 'Scroll to section', className = '', fill = 'white', hoverFill = 'white', onClick, fullWidth = false }) => {
    const [isHovered, setIsHovered] = React.useState(false);

    const handleClick = (e) => {
        // If there's a custom onClick handler, let it handle everything
        if (onClick) {
            onClick(e);
            return;
        }

        // Handle smooth scrolling for anchor links (only if no custom onClick)
        if (href.startsWith('#')) {
            e.preventDefault();
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);
            
            if (targetElement) {
                // Get header height for offset
                const header = document.querySelector('.site-header');
                const headerHeight = header ? header.offsetHeight : 0;
                
                // Calculate target position with offset
                const targetPosition = targetElement.offsetTop - headerHeight;
                
                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            }
        }
    };

    return (
        <a href={href} role="button" onClick={handleClick} style={fullWidth ? { display: 'block', width: '100%' } : undefined}>
            <div
                className={`hero-cta ${className}`}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={fullWidth ? { width: '100%' } : undefined}
            >
                <div className="btn btn-primary text-inherit" style={Object.assign({}, fullWidth ? { flex: 1, textAlign: 'center' } : null, { color: isHovered ? '#fff' : 'inherit', transition: 'none' })}>{primaryText}</div>
                <div className="btn btn-circle" aria-label={ariaLabel}>
                    <svg width="25" height="25" viewBox="0 0 25 25" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.5885 13.9584H0.833252V11.0417H18.5885L10.4218 2.87504L12.4999 0.833374L24.1666 12.5L12.4999 24.1667L10.4218 22.125L18.5885 13.9584Z" fill={isHovered ? hoverFill : fill} style={{ transition: 'none' }} />
                    </svg>
                </div>
            </div>
        </a >
    );
};

export default React.memo(CtaLink);


